import { gql } from 'Utils/apolloClient'

const validateMembershipQuery = gql`
  query Campground($slug: String!, $code: String, $email: String, $dates: [DateRangeAttributes!],
                   $isDailyAccommodation: Boolean, $isExclusive: Boolean) {
    campground(slug: $slug) {
      validateMembership(code: $code, email: $email, dates: $dates, isDailyAccommodation: $isDailyAccommodation,
                         isExclusive: $isExclusive) {
        isValid
        error
      }
    }
  }
`

export default validateMembershipQuery
